import { ComponentStyleConfig, StyleFunctionProps } from '@chakra-ui/react';
import { bodyStyles } from '../../common';
import { getColorVar } from '@chakra-ui/theme-tools';

export const SidebarItemStyles: ComponentStyleConfig = {
  parts: ['container', 'link', 'icon', 'popover', 'popoverLink'],
  baseStyle: (props: StyleFunctionProps) => {
    return {
      container: {
        outline: '2px solid transparent',
        outlineOffset: '-2px',
        position: 'relative',
        display: 'flex',
        alignItems: 'center',
        justifyContent: props.expanded ? '' : 'center',
        backgroundImage: props.match
          ? `linear-gradient(to right, ${getColorVar(props.theme, 'state.selected')} 3px, transparent 3px)`
          : undefined,
        backgroundColor: props.match ? 'tint.primary' : 'transparent',
        _hover: {
          backgroundColor: props.isDisabled
            ? undefined
            : props.match
              ? `color-mix(in srgb, ${getColorVar(props.theme, 'tint.hover')}, ${getColorVar(props.theme, 'tint.primary')})`
              : 'tint.hover',
        },
        '&:focus-visible,&:has(:focus-visible)': {
          outlineColor: 'state.selected',
        },
      },
      link: {
        outline: 'none',
        display: 'flex',
        alignItems: 'center',
        cursor: props.isDisabled ? 'not-allowed' : 'pointer',
        py: 2.5,
        px: 3.5,
        minW: 10,
        minH: 10,
        w: 'full',
        whiteSpace: 'nowrap',
        color: props.match
          ? 'state.selected'
          : props.isDisabled
            ? 'text.disabled'
            : 'text.primary',
      },
      icon: {
        display: 'inline-flex',
        minW: 5,
        minH: 5,
        height: 5,
        width: 5,
        color: props.match
          ? 'inherit'
          : props.isDisabled
            ? 'text.disabled'
            : 'text.primary',
      },
      popover: {
        w: '200px',
      },
      popoverLink: {
        w: 'full',
        py: 2,
        px: 3,
        color: props.isDisabled ? 'text.disabled' : '',
        cursor: props.isDisabled ? 'not-allowed' : 'pointer',
        ...bodyStyles['body-md'],
      },
    };
  },
  defaultProps: {
    expanded: true,
    match: false,
    isDisabled: false,
  },
};
